<template>
  <div>
    <div class="title" v-if="!config.title">{{ config.noneInput ? '*点击文字可编辑答案' : title }}</div>
    <div v-if="config.type === 2">
      <div class="list" v-for="(item, index) in submitList" :key="index">
        <div class="title">{{ config.title }} {{index + 1}} :</div>
        <Record
          :text="item"
          :buttonText="'添加' + config.title"
          :isShowAnswer="isShowAnswer"
          :noneInput="config.noneInput"
          :submitList.sync="submitList"
          @getRecord="getRecord($event, index)"
          :type="index === submitList.length -1 ? 'add'
            : (index !== submitList.length -1 && index > 1 ?'del': '')">
        </Record>
      </div>
    </div>
    <div :class="config.noneInput ? 'answer':''" v-else>
      <div class="submitList" v-show="submitList.length > 0">
        <div v-if="!config.noneInput">
          <span v-for="(item, index) of submitList" :key='item.id'>{{ value }}{{ index + 1 }}：{{ item.title }}</span>
        </div>
        <div v-if="config.noneInput">
          <div class="answer_box" v-for="(item, index) of submitList" :key='item.id'>
            <div class="answer_list inputContent">
              <!--
              <div :id="'text' + index"
                data-input-stats="input_VAR_txt"
                :data-stats-var="index + 1"
                @input="handlerInput($event, index)"
                @blur="handlerBlur($event, index)"
                @paste.prevent @dragover.prevent
                contenteditable="true">
                <span>{{index + 1}}. {{ item.title }}</span>
                </div>
              -->
              <div class="inputItem">
                <!--<span>{{index + 1}}. </span>-->
                <my-editor
                  ref="editor"
                  data-input-stats="input_VAR_txt"
                  :data-stats-var="index + 1"
                  data-contenteditable="true"
                  @input="handlerInput"
                  :type="'ordered_text'"
                  :serialNumber="index + 1"
                  :autoresizeBottomMargin="0"
                  :voiceEntering="record[index]"
                  :voiceEnteringIng="voiceEnteringIng"
                  @paste.prevent
                  @dragover.prevent
                />
              </div>
            </div>
            <img class="answer_icon" data-click-stats="input_VAR_del" :data-stats-var="index + 1" src="./../../../../assets/exam/icon_guanbi.png" @click="deletAnswer(index)" />
          </div>
        </div>
      </div>
      <Record
        class="submit_record"
        :class="rightModelSteer ? 'steerBorder':''"
        :isShowAnswer="isShowAnswer"
        :noneInput="config.noneInput"
        :type='"singleClass"'
        :submitList.sync="submitList"
        @recordEnd="statsRecord"
        @recordStart="recordStart"
        @getRecordContent="getRecordContent"
      ></Record>
      <div class="textInput" data-click-stats="click_txtbutton" @click="addSubmitList">
        <img v-if="rightModelSteer" class="steer_button" :src="require('@/assets/exam/button_kuang.png')" alt=""/>
        文字录入
      </div>
    </div>
  </div>
</template>

<script>
import Record from './record.vue'
import { postProcessStats } from '@/utils/stats'
import MyEditor from '@/component/Editor/Editor.vue';
import { mapMutations } from 'vuex'
import { v4 as uuidv4 } from 'uuid';

export default {
  props: {
    value: {
      type: String,
      default: '答案'
    },
    title: {
      type: String,
      default: '选择录音或键盘输入：'
    },
    isShowAnswer: {
      type: Boolean,
      default: false
    },
    noneInput: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: () => {}
    },
    rightModelSteer: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Record,
    MyEditor
  },
  data() {
    return {
      submitList: [],
      record: new Array(10).fill({ val: '' }),
      voiceEnteringIng: false
    }
  },
  watch: {
    submitList: {
      deep: true,
      handler(el) {
        this.$emit('update:submitList', el)
      }
    }
  },
  mounted() {
    if (this.config.type === 2) {
      this.submitList.push('', '')
    }
  },
  methods: {
    ...mapMutations(['setEditorConetnt']),
    getRecord(obj, index) {
      if (obj.type === 'buttonAdd') {
        this.submitList.push('')
      } else if (obj.type === 'buttonDel') {
        this.submitList.splice(index, 1)
      } else {
        this.submitList[index] = obj.value
      }
    },
    statsRecord() {
      const count = this.submitList.length
      if (count > 0) {
        const item = this.submitList[count - 1]
        postProcessStats({
          event: 'clickinput_VAR_audio',
          statsVar: item.index
        })
      }
      this.voiceEnteringIng = false
      console.log('录音开始 ----->',)
    },
    addSubmitList() {
      this.submitList.push({
        title: '',
        index: this.submitList.length + 1,
        id: uuidv4()
      })
    },
    deletAnswer(index) {
      this.submitList.splice(index, 1)
      this.submitList.forEach((item, index) => {
        item.index = index + 1
      })
      // 缓存输入内容
      this.setEditorConetnt({ index, value: this.submitList[index].title })
      this.$forceUpdate()
    },
    handlerInput(value, index) {
      // 缓存输入内容
      this.setEditorConetnt({ index, value })
      // 去除索引内容
      const regex = /<span[^>]*contenteditable="false"[^>]*>(.*?)<\/span>/
      this.submitList[index].title = value.replace(regex, '').replace(/<p>/g, '<span>').replace(/<\/p>/g, '</span>')
      // this.submitList.splice(index, 1, { title: value.replace(regex, '').replace(/<p>/g, '<span>').replace(/<\/p>/g, '</span>'), index: index + 1 })
      this.$forceUpdate()
    },
    getRecordContent(val) {
      const index = this.submitList.length - 1
      this.record[index].val = val
      this.$refs.editor[index].setRecord(val)
    },
    recordStart() {
      this.voiceEnteringIng = true
    }
  }
}
</script>

<style lang="less" scoped>
.submitList {
  align-items: center;
  padding-top: 10px;
  position: relative;
  span {
    display: block;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666d73;
    line-height: 17px;
    padding: 10px 0px;
  }

  .answer_box{
    width: 100%;
    display: flex;
    align-items: center;
    margin: 10px 0;
    .answer_list{
      // min-width: 200px;
      // max-width: 100%;
      width: 300px;
      min-height: 50px;
      border: 1px solid #B1C6D2;
      border-radius: 25px;
      padding: 5px;
      margin-right: 30px;
      display: inline-block;
      div{
        width: 100%;
        min-height: 40px;
        padding: 10px 15px;
        color: #000000;
        line-height: 20px;
        font-size: 18px;
        border-radius: 20px;
        outline: none;
        overflow: hidden;
        span {
          width: 100%;
          overflow: hidden;
          word-wrap:break-word;
          word-break:break-all;
          padding: 0;
          display: inline-block;
          height: 100%;
          line-height: 22px;
        }
      }
      .inputItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px;
        > span {
          width: 30px;
        }
        > div {
          flex: 1;
        }
      }
    }
    .answer_list:hover{
      div{
        background-color: #E9E9E9;
      }
    }
    img{
      cursor: pointer;
      margin-right: 10px;
      width: 36px;
      height: 36px;
    }
  }
  .tipIcon{
    width: 150px;
    height: 150px;
    position: absolute;
    top: 50px;
    left: 70%;
  }
}
.answer{
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: flex-start;
  .submitList{
    width: calc(100% - 150px);
    // max-height: 320px;
    overflow: hidden;
    overflow-y: auto;
  }
  // .submitList::-webkit-scrollbar {
  //   display: none;
  // }
  .submit_record{
    width: 170px;
    border: 0;
  }
  .textInput{
    width: 76px;
    height: 36px;
    border: 1px solid #B1C6D2;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    margin-top: 12px;
    cursor: pointer;
    margin-right: 20px;
    position: relative;
    .steer_button{
      width: 110px;
      // height: 50px;
      max-width: none;
      top: -4px;
      left: -20px;
      z-index: 105;
      // display: none;
      border-radius: 37%;
      position: absolute;
      background: rgba(0, 0, 0, 0.15);
    }
  }
}
.title {
  margin-top: 22px;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  line-height: 22px;
  font-family: '楷体';
}
</style>
